import { Box, PaginationItem, Skeleton, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { useIsMobile } from "../../../../hooks/responsive";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css";
import { motion } from "motion/react";
import Lives from "./Lives";
import { useGetAllQuestionsQuery } from "../../../../store/api/odyssee";
import { useAuthToken } from "../../../../hooks/auth";
import useOdyssee from "../../../../context/odyssee/useOdyssee";
import CommunityCard from "./CommunityCard";
import Pagination from "@mui/material/Pagination";
import { AnimatePresence } from "motion/react";

const StyledPagination = styled(Pagination)(({ theme }) => ({
	display: "flex",
	gap: 15,
	alignItems: "center",
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
	color: "#ffffff",
	borderColor: "#ffffff",
	borderRadius: "4px",
	fontFamily: "Branding",
	fontWeight: 600,
	margin: "0 5px",
	"&.Mui-selected": {
		backgroundColor: "#ffffff",
		color: "#182B43",
		"&:hover": {
			backgroundColor: "#ffffff",
			color: "#182B43",
		},
	},
	"&:hover": {
		backgroundColor: "rgba(255,255,255,0.64)",
		color: "#182B43",
	},
}));

const Community = ({ goFurther }) => {
	const authToken = useAuthToken();
	const { odyssee } = useOdyssee();

	const [page, setPage] = React.useState(1);
	const handleChange = (event, value) => {
		window.scrollTo(0, 0);
		setPage(value);
	};

	return (
		<motion.div
			transition={{ type: "spring", duration: 1, delay: 0 }}
			initial={{ opacity: 0, scale: 0.95 }}
			animate={{ opacity: 1, scale: 1 }}
		>
			<Box sx={{ fontFamily: "Branding", mt: 8, mb: 8, width: "90vw" }}>
				<motion.div
					transition={{ type: "spring", duration: 1, delay: 0 }}
					initial={{ opacity: 0, scale: 0.95 }}
					animate={{ opacity: 1, scale: 1 }}
					style={{ overflow: "hidden" }}
				>
					<Lives />
				</motion.div>
			</Box>
		</motion.div>
	);
};

export default Community;
